import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import {
  CostSummary,
  Offers,
  ReplacementOffer,
  ToggleState,
  UpfrontPaymentSummary,
} from '@dgx-pr-spa/shared/util';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
@Component({
  selector: 'app-summary-header-container',
  templateUrl: './summary-header-container.component.html',
  styleUrls: ['./summary-header-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryHeaderContainerComponent implements OnChanges {
  constructor(
    public completeOrderService: CompleteOrderService,
    public viewOffersService: ViewOffersService,
    private router: Router
  ) {}

  text = 'Show';
  showProtectionNotice = false;

  optimizely$ = this.viewOffersService.optimizely$;

  @Input() selected: ReplacementOffer;
  @Input() costSummary: CostSummary;
  @Input() upfrontPaymentSummary: UpfrontPaymentSummary;
  @Input() offers: Offers;
  @Input() offerError: boolean;
  @Input() previousUrl: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.offers) {
      this.showProtectionNotice =
        !this.offers?.offer?.upsell_flag &&
        this.offers?.offer?.upsell_reason.toLowerCase() === 'multiplan';
    }
  }

  isOpenClick(state: ToggleState) {
    this.text = state === ToggleState.open ? 'Hide' : 'Show';
  }

  routeBack() {
    if (this.previousUrl.includes('protection') && !this.offerError) {
      this.router.navigate(['/protection'], {
        queryParamsHandling: 'preserve',
      });
    } else {
      this.router.navigate(['/services'], { queryParamsHandling: 'preserve' });
    }
  }
}
